import React from 'react'
import { arrayOf, number, shape, string } from 'prop-types'
import {
  AUTO_STEPS,
  HOME_STEPS,
  HOME_STEPS_BCREDI,
  PRODUCTS,
} from 'domain/enums'
import { Aside, Title } from './Lead.styles'
import { StepCard } from './StepCard'

const propTypes = {
  steps: arrayOf(
    shape({
      name: string,
      order: number,
      progress: shape({
        startedAt: string,
        finishedAt: string,
      }),
      rejectionReason: string,
    }),
  ),
  product: string,
}

const Steps = ({ steps, product }) => {
  const getHomeStepsByAllowlist = () => {
    const HOME_STEPS_LENGTH = 4
    if (steps.length > HOME_STEPS_LENGTH) {
      return HOME_STEPS_BCREDI
    }

    return HOME_STEPS
  }

  const productSteps = () => {
    switch (product) {
      case PRODUCTS.AUTO:
        return AUTO_STEPS
      case PRODUCTS.HOME:
        return getHomeStepsByAllowlist()
      default:
        return []
    }
  }

  const getRecentStep = () => {
    if (!steps) return null
    let recentStep
    productSteps().forEach(stepName => {
      const matchedStep = steps.find(step => step.name === stepName)
      if (matchedStep?.progress?.startedAt) {
        recentStep = matchedStep
      }
    })

    return recentStep
  }

  const mostRecentStep = getRecentStep()

  return (
    <Aside data-testid="steps">
      <Title variant="h4">Etapas</Title>
      {productSteps &&
        steps &&
        productSteps()?.map((stepName, index) => (
          <StepCard
            key={index}
            step={steps.find(step => step.name === stepName)}
            isCurrentStep={stepName === mostRecentStep?.name}
          />
        ))}
    </Aside>
  )
}

Steps.propTypes = propTypes

export { Steps }
